// ** React Imports
import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {Roles} from "@configs/roles/ProjectRole";

// ** Custom Components
import Avatar from '@components/avatar'

// ** Utils
// ** Store & Actions
import {useDispatch} from 'react-redux'
import {store} from "@store/storeConfig/store";
import {handleLogout} from "@store/actions/auth";

// ** Third Party Components
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from 'reactstrap'
import {Power, User} from 'react-feather'
// import formatPrice from "@configs/utils/priceFormatter";


// ** Default Avatar Image
import defaultAvatar from '@src/assets/images/portrait/small/avatar-s-86.jpg'
import jwtDecode from "jwt-decode";
import {RiArrowDownSLine} from "react-icons/ri";

const UserDropdown = () => {
    // ** Store Vars
    const dispatch = useDispatch()

    // ** State
    const [userData, setUserData] = useState(null)

    //** ComponentDidMount
    useEffect(() => {
        let token = localStorage.getItem('token');
        if (token) {
            try {
                setUserData(jwtDecode(token))
            } catch (e) {
                store.dispatch(handleLogout())
            }
        }

    }, [])

    //** Vars
    const userAvatar = (userData && userData.avatar) || defaultAvatar

    //const profilePagePath = userData && userData.roles[0] === Roles.customer ? '/panel/user-info' : userData && userData.roles[0] === Roles.expert ? "/panel/expert-info" : userData && userData.roles[0] === Roles.Representative ? "/panel/representative-info" : "/";


    return (
        <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
            <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
                <RiArrowDownSLine/>
                <div className='user-nav d-sm-flex d-none'>
                    <span
                        className='user-name font-weight-bold'>
                        {userData && `${userData.first_name} ${userData.last_name}`}</span>
                    {/*                 <span
                        className='user-status'>{(userData && userData.role && userData.role[0] === Roles.admin) ? "مدیر" : (userData && userData.role && userData.role[0] === Roles.expert)  ? "کارشناس" : (userData && userData.role && userData.role[0] === Roles.Representative) ? "نماینده" : "کاربر"  }</span>*/}
                </div>
                {/*<Avatar img={userAvatar} imgHeight='40' imgWidth='40' status='online'/>*/}
            </DropdownToggle>
            <DropdownMenu right={false}>
                {/* {!((userData && userData.roles[0]) === Roles.admin) &&
                    < DropdownItem tag={Link} to={profilePagePath ? profilePagePath : "/"}><User size={14} className='mr-75'/>
                    <span className='align-middle'>اطلاعات کاربری</span>
                    </DropdownItem>
                }*/}
                <DropdownItem tag={Link} to={'/'} onClick={() => dispatch(handleLogout())}>
                    <Power size={14} className='mr-75'/>
                    <span className='align-middle'>خروج</span>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default UserDropdown
